import { QuoteReservation } from '@/models/quote'
import { Service } from '@/models/service'

export function getServiceDays(
  cartReservations: QuoteReservation[],
  service: Service | null
): number[] {
  if (cartReservations.length === 0 || service === null) {
    return []
  }
  const [firstReservation] = cartReservations
  const boughtService = firstReservation.boughtServices[service.serviceId]
  if (!boughtService) {
    // fallback to days of the daily schedule
    const keys = Object.keys(service.dailyTimeSchedules)
    return keys
      .map((key) => parseInt(key))
      .filter((time) => !Number.isNaN(time))
  }

  const days = Object.values(boughtService)
    .map((item) => item.days)
    .flat()

  return Array.from(new Set(days))
}
